"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "HooksService", {
    enumerable: true,
    get: function() {
        return HooksService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _View = /*#__PURE__*/ _interop_require_default(require("../models/View"));
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _populateSamplePayload = require("~/helpers/populateSamplePayload");
const _webhookHelpers = require("~/helpers/webhookHelpers");
const _models = require("~/models");
const _datasservice = require("~/services/datas.service");
const _Jobs = require("~/interface/Jobs");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const SUPPORTED_HOOK_VERSION = [
    'v3'
];
let HooksService = class HooksService {
    validateHookPayload(notificationJsonOrObject) {
        let notification = {};
        try {
            notification = typeof notificationJsonOrObject === 'string' ? JSON.parse(notificationJsonOrObject) : notificationJsonOrObject;
        } catch (unused) {}
        if (notification.type !== 'URL' && notification.type !== 'Script' && process.env.NC_CLOUD === 'true') {
            _catchError.NcError.badRequest('Only URL and Script notifications are supported');
        }
    }
    async hookList(context, param) {
        return await _models.Hook.list(context, {
            fk_model_id: param.tableId
        });
    }
    async hookLogList(context, param) {
        return await _models.HookLog.list(context, {
            fk_hook_id: param.hookId
        }, param.query);
    }
    async hookCreate(context, param, option) {
        var _param_hook;
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        // if isTableDuplicate, we let v2 to be created
        if (!(option == null ? void 0 : option.isTableDuplicate) && !SUPPORTED_HOOK_VERSION.includes(param.hook.version)) {
            _catchError.NcError.get(context).badRequest('hook version is deprecated / not supported anymore');
        }
        if (!((_param_hook = param.hook) == null ? void 0 : _param_hook.trigger_field)) {
            param.hook.trigger_field = false;
        }
        if (!(option == null ? void 0 : option.isTableDuplicate)) {
            (0, _helpers.validatePayload)('swagger.json#/components/schemas/HookReq', param.hook);
        }
        this.validateHookPayload(param.hook.notification);
        // if version is not in SUPPORTED_HOOK_VERSION, that means it's a duplicate table activity
        // then we use v2 insert
        // otherwise v3 insert
        const hook = !SUPPORTED_HOOK_VERSION.includes(param.hook.version) ? await _models.Hook.insertV2(context, _extends({}, param.hook, {
            fk_model_id: param.tableId
        })) : await _models.Hook.insert(context, _extends({}, param.hook, {
            fk_model_id: param.tableId
        }));
        this.appHooksService.emit(_nocodbsdk.AppEvents.WEBHOOK_CREATE, {
            hook,
            req: param.req,
            context,
            tableId: hook.fk_model_id
        });
        return hook;
    }
    async hookDelete(context, param) {
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const hook = await _models.Hook.get(context, param.hookId);
        if (!hook) {
            _catchError.NcError.get(context).hookNotFound(param.hookId);
        }
        const buttonCols = await _models.Hook.hookUsages(context, param.hookId);
        if (buttonCols.length) {
            for (const button of buttonCols){
                await _models.ButtonColumn.update(context, button.fk_column_id, {
                    fk_webhook_id: null
                });
            }
            await _View.default.clearSingleQueryCache(context, hook.fk_model_id);
        }
        await _models.Hook.delete(context, param.hookId);
        this.appHooksService.emit(_nocodbsdk.AppEvents.WEBHOOK_DELETE, {
            hook,
            req: param.req,
            context,
            tableId: hook.fk_model_id
        });
        return true;
    }
    async hookUpdate(context, param) {
        var _param_hook;
        if (!SUPPORTED_HOOK_VERSION.includes(param.hook.version)) {
            _catchError.NcError.get(context).badRequest('hook version is deprecated / not supported anymore');
        }
        if (!((_param_hook = param.hook) == null ? void 0 : _param_hook.trigger_field)) {
            param.hook.trigger_field = false;
        }
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/HookReq', param.hook);
        const hook = await _models.Hook.get(context, param.hookId);
        if (!hook) {
            _catchError.NcError.get(context).hookNotFound(param.hookId);
        }
        this.validateHookPayload(param.hook.notification);
        // If the webhook is being changed to manual trigger, set it to active
        if (param.hook.event === 'manual') {
            param.hook.active = true;
        }
        if (hook.active && !param.hook.active || hook.event !== param.hook.event) {
            const buttonCols = await _models.Hook.hookUsages(context, param.hookId);
            if (buttonCols.length) {
                for (const button of buttonCols){
                    await _models.ButtonColumn.update(context, button.fk_column_id, {
                        fk_webhook_id: null
                    });
                }
            }
            await _View.default.clearSingleQueryCache(context, hook.fk_model_id);
        }
        const res = await _models.Hook.update(context, param.hookId, param.hook);
        this.appHooksService.emit(_nocodbsdk.AppEvents.WEBHOOK_UPDATE, {
            hook: _extends({}, hook, param.hook),
            oldHook: hook,
            tableId: hook.fk_model_id,
            req: param.req,
            context
        });
        return res;
    }
    async hookTrigger(context, param) {
        const hook = await _models.Hook.get(context, param.hookId);
        if (!hook && hook.event !== 'manual') {
            _catchError.NcError.get(context).badRequest('Hook not found');
        }
        const row = await this.dataService.dataRead(context, {
            rowId: param.rowId,
            query: {},
            baseName: hook.base_id,
            tableName: hook.fk_model_id
        });
        if (!row) {
            _catchError.NcError.get(context).badRequest('Row not found');
        }
        const model = await _models.Model.get(context, hook.fk_model_id);
        try {
            await this.jobsService.add(_Jobs.JobTypes.HandleWebhook, {
                hookId: hook.id,
                modelId: model.id,
                viewId: null,
                prevData: null,
                newData: row,
                user: param.req.user,
                context,
                hookName: 'manual.trigger',
                ncSiteUrl: param.req.ncSiteUrl
            });
        } catch (e) {
            _catchError.NcError.get(context).webhookError((e == null ? void 0 : e.message) || 'Failed to trigger webhook');
        } finally{
        /*this.appHooksService.emit(AppEvents.WEBHOOK_TRIGGER, {
        hook,
        req: param.req,
      });*/ }
        return true;
    }
    async hookTest(context, param) {
        var _param_hookTest_hook, _hook_notification;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/HookTestReq', param.hookTest);
        this.validateHookPayload((_param_hookTest_hook = param.hookTest.hook) == null ? void 0 : _param_hookTest_hook.notification);
        const model = await _models.Model.getByIdOrName(context, {
            id: param.tableId
        });
        const { hook, payload: { data, user } } = param.hookTest;
        let view = null;
        if (hook == null ? void 0 : (_hook_notification = hook.notification) == null ? void 0 : _hook_notification.trigger_form_id) {
            view = await _View.default.get(context, hook.notification.trigger_form_id);
        }
        try {
            var _ref;
            await (0, _webhookHelpers.invokeWebhook)(context, {
                hook: new _models.Hook(hook),
                model: model,
                view: view,
                prevData: (_ref = data == null ? void 0 : data.previous_rows) != null ? _ref : null,
                newData: data.rows,
                user: user,
                testFilters: hook == null ? void 0 : hook.filters,
                throwErrorOnFailure: true,
                testHook: true,
                hookName: hook.event + '.' + hook.operation[0],
                ncSiteUrl: param.req.ncSiteUrl,
                addJob: this.jobsService.add.bind(this.jobsService)
            });
        } catch (e) {
            if (e instanceof _catchError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
            _catchError.NcError.get(context).webhookError((e == null ? void 0 : e.message) || 'Failed to trigger webhook');
        } finally{
            this.appHooksService.emit(_nocodbsdk.AppEvents.WEBHOOK_TEST, {
                hook,
                req: param.req,
                context,
                tableId: hook.fk_model_id
            });
        }
        return true;
    }
    async hookSamplePayload(context, param) {
        const model = await _models.Model.getByIdOrName(context, {
            id: param.tableId
        });
        if (param.version === 'v1') {
            return await (0, _populateSamplePayload.populateSamplePayload)(context, model, false, param.operation);
        }
        if (param.event === _nocodbsdk.WebhookEvents.VIEW) {
            return await (0, _populateSamplePayload.populateSamplePayloadView)(context, {
                viewOrModel: model,
                operation: param.operation,
                includeUser: param.includeUser,
                user: param.user,
                version: param.version
            });
        }
        return await (0, _populateSamplePayload.populateSamplePayloadV2)(context, model, false, param.operation, 'records', param.includeUser, param.user);
    }
    async tableSampleData(context, param) {
        const model = new _models.Model(await _models.Model.getByIdOrName(context, {
            id: param.tableId
        }));
        if (param.version === 'v1') {
            return await (0, _populateSamplePayload.populateSamplePayload)(context, model, false, param.operation);
        }
        if (param.event === _nocodbsdk.WebhookEvents.VIEW) {
            return await (0, _populateSamplePayload.populateSamplePayloadView)(context, {
                viewOrModel: model,
                operation: param.operation,
                includeUser: param.includeUser,
                user: undefined,
                version: param.version
            });
        }
        return await (0, _populateSamplePayload.populateSamplePayloadV2)(context, model, false, param.operation, undefined, param.includeUser, undefined, param.version);
    }
    async hookLogCount(context, param) {
        return await _models.HookLog.count(context, {
            hookId: param.hookId
        });
    }
    constructor(appHooksService, dataService, jobsService){
        this.appHooksService = appHooksService;
        this.dataService = dataService;
        this.jobsService = jobsService;
    }
};
HooksService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(2, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _datasservice.DatasService === "undefined" ? Object : _datasservice.DatasService,
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService
    ])
], HooksService);
